import React, { useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Row,
  Spinner,
} from "reactstrap";

// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

import { KeyBoard } from "../../../components/paymennts/KeyBoard";
import { DataTitles } from "../../../components/paymennts/DataTitles";
import { ServicesMenu } from "../../../components/shared/ServicesMenu";

import { getDataPayments } from "../../../services/paymentService";

import logoMorona from "../../../assets/img/gadm.png";

import "../../../assets/css/payments.css";

const Payment = () => {
  const [ci, setCi] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [flag, setFlag] = useState(true);
  const [showForm, setShowForm] = useState(true);
  const [showLoading, setShowLoading] = useState(false);

  // const MySwal = withReactContent(Swal);

  const changeValueCiField = (evt) => {
    const ciInputValue = evt.target.value;
    setCi(ciInputValue);
    if (ciInputValue.length === 10 || ciInputValue.length === 13) {
      setFlag(false);
    } else {
      setFlag(true);
    }
  };

  const handleSumbit = async (event, error) => {
    event.preventDefault();
    setShowLoading(true);

    const response = await getDataPayments(ci);

    setShowLoading(false);

    if (response.status === 200) {
      setShowForm(false);
      setResponseData(response.data);
    } else {
      alert(response.data);
    }
  };

  function activeForm() {
    setShowForm(true);
    setCi("");
    setResponseData(null);
  }
  return (
    <>
      <ServicesMenu />
      <Container>
        <Row>
          <Col md={12}>
            <Card className="mt-2 p-3">
              <CardBody id="card-payment">
                <Row className={"row mt-3 mb-1"}>
                  <Col lg="12" md="12" sm="12">
                    <div className="cont-header-desc">
                      <img src={logoMorona} alt="Logo del GAD Morona" />
                      <h1 className="font-weight-normal">
                        GOBIERNO MUNICIPAL DEL CANTÓN MORONA
                      </h1>
                      <h3>Consulta de Valores a Pagar</h3>
                      <p>
                        Los pagos inmediatos no se reflejan en la lista de pagos
                        pendientes. Estos pagos se generan cuando se realiza el
                        trámite o pago del impuesto y se cancela en ventanilla.
                      </p>
                    </div>
                  </Col>
                  <Col md="12">
                    {showForm ? (
                      <div className="cont-tactil">
                        <Form
                          className="auth-login-form mt-2"
                          onSubmit={handleSumbit}
                        >
                          <FormGroup>
                            <Input
                              required
                              autoFocus
                              valid={!flag}
                              type="text"
                              pattern="[0-9]{10,10}"
                              id="ci-field"
                              name="ci_field"
                              value={ci}
                              placeholder="Cédula de Identidad o RUC"
                              readOnly={true}
                              onChange={(e) => changeValueCiField(e)}
                            />
                          </FormGroup>
                          <div id="cont-numbers">
                            <KeyBoard
                              fieldValue={ci}
                              setFieldValue={setCi}
                              setFlag={setFlag}
                            />
                          </div>
                          <div id="cont-button">
                            <Button
                              disabled={!ci.length || flag}
                              className="p-1"
                              color="success"
                              size="lg"
                              block
                            >
                              Consultar
                              {showLoading ? <Spinner color="light" /> : null}
                            </Button>
                          </div>
                        </Form>
                      </div>
                    ) : (
                      <div id="cont-newquery">
                        <Button color="info" onClick={activeForm}>
                          Nueva Consulta
                        </Button>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" md="12" sm="12">
                    {responseData ? (
                      <>
                        <DataTitles data={responseData} />
                      </>
                    ) : null}
                  </Col>
                </Row>
              </CardBody>
              {/* <div id="ilustration-payment">
                <img
                    className="img-fluid d-none d-md-block"
                    src={banner}
                    alt="illustration"
                    style={{ transform: 'scaleX(1)' }}
                />
            </div> */}
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Payment;
